import type { CSSProperties, FC, ReactNode } from 'react'

import Image from 'next/image'

import { galleryColumns } from '@/constants/metric'

const speeds = ['26s', '20s', '31s', '23s', '28s']

export const GallerySection: FC = (): ReactNode => {
    return (
        <section
            id='gallery'
            aria-label='Themes running through Metric'
            className='relative h-[190vh] px-0 tab:px-[60px]'
        >
            <div className='sticky top-0 h-svh overflow-hidden'>
                <div
                    data-gallery-panel
                    className='fw-container flex h-full gap-1 tab:gap-1.5'
                    style={{
                        maskImage: 'linear-gradient(#0000 0%, #000 18%, #000 72%, #0000 100%)',
                        WebkitMaskImage: 'linear-gradient(#0000 0%, #000 18%, #000 72%, #0000 100%)'
                    }}
                >
                    {galleryColumns.map((column, index) => (
                        <div
                            key={column.label}
                            className={[
                                'h-full min-w-0 flex-1 overflow-hidden',
                                index > 2 ? 'hidden tab:block' : '',
                                index === 2 ? 'hidden sm:block' : ''
                            ].join(' ')}
                        >
                            <ul
                                className='fw-ticker-track-y flex flex-col gap-1 tab:gap-1.5'
                                style={{
                                    '--ticker-duration': speeds[index % speeds.length],
                                    animationDirection: index % 2 === 1 ? 'reverse' : 'normal'
                                } as CSSProperties}
                            >
                                {[...column.images, ...column.images, ...column.images, ...column.images].map((image, imageIndex) => (
                                    <li key={`${column.label}-${imageIndex}`} className='flex flex-col gap-1'>
                                        <div className='relative aspect-[3/4] w-full overflow-hidden rounded-[9px] border border-line'>
                                            <Image
                                                src={image}
                                                alt=''
                                                fill
                                                sizes='(max-width: 810px) 45vw, 240px'
                                                className='object-cover saturate-[0.9]'
                                            />

                                            <span aria-hidden='true' className='fw-noise absolute inset-0 opacity-[0.08]' />
                                        </div>

                                        <span className='block truncate rounded-[9px] border border-line bg-surface px-3 py-2 text-center font-body text-[12px] font-medium leading-[1.3em] text-ink-soft'>
                                            {column.label}
                                        </span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    )
}
